<template>
    <div class="configuration-buildings-container">
        <buildings-list 
            :buildings="allBuildings" 
            :isLoading="isLoading"
        />
        <v-card class="workspace-card-container">
            <h3 class="workspace-title">Map</h3>
            <div class="workspace-container">
                <workspace-map
                    ref="workspaceMap"
                    :workspace="workspace"
                    :polygon="polygon"
                    :draw-polygon="false"
                    :view-all-workspaces="false"
                    :is-npv="true"
                    :is-npv-buildings="true"
                    :buildings="allBuildings"
                />
            </div>
        </v-card>
    </div>
</template>
  
<script>
    import { mapActions } from "vuex";
    import BuildingsList from "../components/BuildingsList.vue";
    import WorkspaceMap from '@/components/ProjectManagement/Workspaces/WorkspaceMap';
    import { configurationsMixin } from "@/mixins/npv/configurationsMixin";
    export default {
        name: "ConfigurationBuildings",
        components: {
            BuildingsList,
            WorkspaceMap
        },
        mixins: [configurationsMixin],
        data(){
            return {
                allBuildings: [],
                isLoading: false,
                noDataMessage: null,
            }
        },
        mounted() {
            this.getBuildings();
            this.getSelectedWorkspace();
        },
    
        methods: {
            ...mapActions([
                "GET_ALL_BUILDINGS_NPV",
                "fetchAllWorkspaces", 
                "setProjection", 
                "setWorkspaceGeomatry", 
                "setWorkspace", 
                "clearWorkspace", 
                "clearWorkspaceGeometry"
            ]),
            
            getSelectedWorkspace(){
                if(!this.$store.getters.getWorkspace){
                    this.polygon = this.convertToGeoJSON(this.$store.getters.getWorkspaceGeometry);
                }else{
                    this.workspace = this.$store.getters.getWorkspace;
                }
            },
            async getBuildings(){
                try{
                    this.isLoading = true;
                    const buildings = await this.GET_ALL_BUILDINGS_NPV({
                        polygon: this.$store.getters.getWorkspaceGeometry,
                        projection: this.$store.getters.getProjection
                    });
                    if(buildings.length > 0){
                        this.allBuildings = buildings;
                    }else{
                        this.noDataMessage = 'No buildings found'
                    }
                }catch(err){
                    console.log(err);
                }finally{
                    this.isLoading = false;
                }
                 
            },
            getProjection() {
                const projection = this.$refs.workspaceMap.getProjection()
                return projection
            },
        }
    };
</script>
<style scoped>
  .configuration-buildings-container{
    width: 100%;
    height: calc(100% - 110px);
    display: flex;
  }

  .workspace-card-container{
    width: 88%;
    height: 100%;
    margin-top: 15px;
    margin-left: 10px;
    padding: 0px 40px 40px 40px;
  }
  .workspace-title{
    padding-top: 20px;
    text-align: left;
    color: #4fa2b7;
    padding-bottom: 25px;
  }
  .workspace-container{
    width: 100%;
    height: calc(100% - 70px);
  }
</style>
  


// WEBPACK FOOTER //
// src/components/Npv/Configuration/views/ConfigurationBuildings.vue